import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import type { IApiEnvelope, IEnvelopeClient } from './api-envelope.types';

export type AutomatedFreightStatus = 'OK' | 'NO_FREIGHT_ROW' | 'NO_FREIGHT_BASIS' | 'NO_RATE' | 'NO_DIMENSIONS';

export interface AutomatedFreightDto {
  status: AutomatedFreightStatus;
  freightBasis: string | null;
  rate: number | null;
  volume: number | null;
  volumeUnit: 'CBM' | 'CFT' | null;
  totalCost: number | null;
  currency: string | null;
}

const api = apiClient as unknown as IEnvelopeClient;

export const getAutomatedFreightService = (devOrderId: string): Promise<IApiEnvelope<AutomatedFreightDto>> =>
  api.get<AutomatedFreightDto>(`${apiEndpoint}${API.AUTOMATED_FREIGHT.BY_DEV_ORDER.replace(':devOrderId', devOrderId)}`);
